import { Tutor, TutorSettingItem } from '../../services/tutor.service';

/**
 * Regeln über den Einrichtungsstand, die Portalhinweise UND Academy-
 * Lektionen (Erledigt-Prüfung, `academy/academy-done-checks.ts`) nutzen —
 * eine Stelle, damit Hinweis und Lektion nie Verschiedenes für „erledigt“
 * halten.
 */

/** localStorage-Merkmal „Vorschau-Chat schon benutzt“, je `<client>:<user>`
 *  (Portalhinweis 4 und Academy-Lektion `try-agent`). */
export const PREVIEW_TRIED_KEY = 'al-portal-hints-tried-v1';

/** Agent hat einen Wissensbasis-Ordner verknüpft. */
export function hasLinkedFolder(t: Tutor): boolean {
  return (t.tutor_data_source_ids ?? t.data_source_ids ?? []).length > 0;
}

/** Agent bekommt Kurswissen über Platzierungen (Kurs-Sync). */
export function hasCourseKnowledge(t: Tutor): boolean {
  return (t.live_course_count ?? 0) > 0;
}

/** Wert von `knowledge_mode` (Wissens-Modus) aus der Einstellungsliste eines
 *  Agenten — eigener Wert, sonst der Vorlagen-Standard; JSON-Anführungs-
 *  zeichen aus der Datenbank (`"open"`) werden entfernt. */
export function readKnowledgeMode(items: TutorSettingItem[] | null | undefined): string | null {
  const item = items?.find((i) => i.variable_name === 'knowledge_mode');
  if (!item) return null;
  const raw = item.value ?? item.default_value;
  if (raw === null || raw === undefined || raw === '') return null;
  return String(raw).replace(/^"+|"+$/g, '');
}
